import { render, staticRenderFns } from "./RolePropertyManage.vue?vue&type=template&id=0b9db442"
import script from "./RolePropertyManage.vue?vue&type=script&lang=js"
export * from "./RolePropertyManage.vue?vue&type=script&lang=js"
import style0 from "./RolePropertyManage.vue?vue&type=style&index=0&id=0b9db442&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports